import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import useCustomStyles from '../hooks/useCustomStyles';
import { header2Styles } from '../assets/styles/header2';
import { selectTranslationState } from '../store/slices/languageSlice';

interface ConfirmLogoutModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmLogoutModal: React.FC<ConfirmLogoutModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const { theme, activeTheme, textTheme } = useSelector((state: RootState) => state.theme_slice);
  const classes = useCustomStyles(header2Styles, theme);
  const { t } = useSelector(selectTranslationState);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onCancel();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className={classes.overlay}>
      <div className={classes.modal} ref={modalRef}>
    
        <h2 className={classes.headerTextLogOutModal}>{t[textTheme].profileViewScreen.logout.confirmLogout.title}</h2>
    <p className={classes.headerTextLogOutModal}>{t[textTheme].profileViewScreen.logout.confirmLogout.subTitle}</p>
        <div className={classes.buttons}>
          <button onClick={onConfirm} className={classes.confirmButton}>
            {t[textTheme].profileViewScreen.logout.confirmLogout.confirmButton.text}
          </button>
          <button onClick={onCancel} className={classes.cancelButton}>
            {t[textTheme].profileViewScreen.logout.confirmLogout.cancelButton.text}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmLogoutModal;
